import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EstadoDescargaCertificadoStepperService {
  private readonly stepCurrent$ = new BehaviorSubject<number>(0);

  get stepCurrent(): Observable<number> {
    return this.stepCurrent$.asObservable();
  }

  setStepCurrent(value: number) {
    this.stepCurrent$.next(value);
  }
}
